import React from 'react';
import { Button } from '@/components/ui/button';
import { AlertTriangle } from 'lucide-react';
import { useErrorReporting } from '@/hooks/useErrorReporting';
interface EnhancedToastProps {
  title: string;
  description: string;
  variant?: 'default' | 'destructive';
  showReportButton?: boolean;
  error?: Error;
  context?: any;
}
export const EnhancedToast: React.FC<EnhancedToastProps> = ({
  title,
  description,
  variant = 'default',
  showReportButton = false,
  error,
  context
}) => {
  const {
    reportError,
    loading
  } = useErrorReporting();
  const handleReportError = async () => {
    console.log('[ENHANCED_TOAST] Reporting error via toast button');
    await reportError(description, error, context);
  };
  return <div className="space-y-2">
      <div className="flex items-start gap-2">
        {/* Het icoon staat alleen in de rode melding: rood op rood was niet te zien. */}
        {variant === 'destructive' && <AlertTriangle className="h-4 w-4 text-destructive-foreground mt-0.5 flex-shrink-0" />}
        <div className="flex-1">
          <div className="font-semibold">{title}</div>
          {/* In de rode melding de eigen tekstkleur van die melding: gedempt grijs is op rood niet te lezen. */}
          <div className={variant === 'destructive' ? 'text-sm text-destructive-foreground' : 'text-sm text-muted-foreground'}>{description}</div>
        </div>
      </div>
      
      {showReportButton && variant === 'destructive' && <Button onClick={handleReportError} disabled={loading} variant="outline" size="sm" className="w-full text-slate-950">
          {loading ? 'Verzenden...' : 'Meld aan beheerder'}
        </Button>}
    </div>;
};

// Helper function to create enhanced error toasts
export const createErrorToast = (toast: any) => {
  return (title: string, description: string, error?: Error, context?: any) => {
    toast({
      description: <EnhancedToast title={title} description={description} variant="destructive" showReportButton={true} error={error} context={context} />,
      variant: 'destructive',
      duration: 8000 // Longer duration for error toasts with report button
    });
  };
};